import { render } from "./index.vue?vue&type=template&id=05510670&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=05510670&lang=scss&scoped=true"

import exportComponent from "E:\\workProject\\App.Live.Department.PC\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05510670"]])

export default __exports__